import { ClassWatcher } from '@utils/class-watcher'
/**
 * @module input-listener
 * Allows a given input-type element to listen for changes in other form elements,
 * concatenating the values ​​and set to its own value.
 * @example
 * <input type="text" data-for="example" />
 * <input type="text" data-for="example" />
 * <input type="hidden" id="example" v-input-listener />
 */
export const inputListener = {
  name: 'input-listener',
  inserted: (el) => {
    const selector = `[data-for="${el.id}"]`
    const targets = Array.from(document.querySelectorAll(selector))
    const errorClass = 'input-validation-error'
    const addClass = () => {
      targets.forEach((t) => {
        t.classList.add(errorClass)
        t.classList.remove('valid')
      })
    }
    const removeClass = () => {
      targets.forEach((t) => {
        t.classList.remove(errorClass)
      })
    }

    targets.forEach((t) => {
      t.addEventListener('change', () => {
        el.dispatchEvent(new Event('update'))
        if (!t.value) {
          t.classList.add('no-value')
          t.classList.remove('valid')
        } else {
          t.classList.remove('no-value')
        }
      })
    })

    el.addEventListener('update', () => {
      el.value = targets.map((target) => target.value).join(' ')
    })

    el.listener = new ClassWatcher(el, errorClass, addClass, removeClass)
  }
}
